import {
  ApplicationBookingState,
  ApplicationState,
  PrivateApplicationData,
  PublicApplicationData,
} from '@flatsy/types/Applications'
import {
  BookingState,
  FrontApplicationBookingState,
} from '@flatsy/types/Applications/BookingStatus'
import { FrontApplicationState, State } from '@flatsy/types/Applications/Status'
import { CancelBy } from '@flatsy/types/Bookings'
import { formatISO9075, isPast, parseISO } from 'date-fns'
import { parseApiDate } from '../Functions/DateTime/Date'

export const toFrontendApplicationState = (
  state?: State,
  bookingState?: ApplicationBookingState
): State | undefined => {
  if (!state || !bookingState) {
    return undefined
  }

  if (
    bookingState &&
    (state === ApplicationState.REVIEWING ||
      state === ApplicationState.UPLOADING ||
      state === ApplicationState.COMPLETED) &&
    bookingState === ApplicationBookingState.UNAUTHORIZED
  ) {
    return FrontApplicationState.WAITING_LIST
  }

  if (
    state === ApplicationState.UPLOADING ||
    state === ApplicationState.REVIEWING ||
    state === ApplicationState.COMPLETED ||
    state === ApplicationState.ACCEPTED
  ) {
    return FrontApplicationState.SUCCESS
  }

  if (
    state === ApplicationState.REFUSED ||
    state === ApplicationState.ABANDONED ||
    state === ApplicationState.UNQUALIFIED
  ) {
    return FrontApplicationState.FAILED
  }

  return state
}

export const toFrontendApplicationBookingState = (
  application: PrivateApplicationData | PublicApplicationData
): BookingState | undefined => {
  if (!application || !application.booking) {
    return undefined
  }

  if (application.booking?.cancelled_by) {
    if (application.booking?.cancelled_by === CancelBy.RESCHEDULING) {
      return FrontApplicationBookingState.RESCHEDULED
    }
    return FrontApplicationBookingState.CANCELLED
  }

  if (application.booking?.start_date && application.booking.start_time) {
    const date = formatISO9075(
      parseISO(`${application.booking.start_date}T${application.booking.start_time}`)
    )
    if (date && isPast(parseApiDate(date))) {
      return ApplicationBookingState.COMPLETED
    }
  }

  return application.booking_state
}
